import axios from '@/plugins/axios'
import { MessageBox } from 'element-ui'

export default {
  namespaced: true,

  state: {
    loading: false,
    submissions: [],
    page: 1,
    page_size: 10,
    total: 0,
    page_count: 0,
    order_column: 'created_at',
    order_type: 'desc',
    selectedSubmission: { image_verification: {}, task: {} },
    verificationDialog: false,
    verificationStatusFilter: '',
    quest: ''
  },

  mutations: {
    setSubmissions(state, payload) {
      state.submissions = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setTotal(state, payload) {
      state.total = payload
    },
    setPageCount(state, payload) {
      state.page_count = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    reset(state) {
      state.submissions = []
      state.page = 1
      state.page_size = 10
      state.total = 0
      state.page_count = 0
      state.order_column = 'id'
      state.order_type = 'desc'
      state.loading = false
      state.quest = ''
    },
    setSelectedSubmission(state, payload) {
      state.selectedSubmission = payload
    },
    setVerificationDialog(state, payload) {
      state.verificationDialog = payload
    },
    setVerificationStatusFilter(state, payload) {
      state.verificationStatusFilter = payload
    },
    setQuest(state, payload) {
      state.quest = payload
    }
  },

  actions: {
    read({ commit, state }, queryParams = {}) {
      commit('setLoading', true)
      
      const params = {
        page: state.page,
        page_size: state.page_size,
        order_column: state.order_column,
        order_type: state.order_type,
        verification_status: state.verificationStatusFilter,
        quest: state.quest,
        ...queryParams
      }
      
      // Remove empty values
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key]
        }
      })
      
      axios.admin
        .get('/web3/submissions', { params })
        .then(r => {
          if (r.data.success && r.data.submissions) {
            commit('setSubmissions', r.data.submissions.data)
            commit('setTotal', r.data.submissions.total)
            commit('setPageCount', r.data.submissions.last_page)
          } else {
            commit('setSubmissions', r.data.data)
            commit('setTotal', r.data.total)
            commit('setPageCount', r.data.last_page)
          }
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    manualVerify({ dispatch }, submissionId) {
      return axios.admin
        .put(`/web3/submissions/${submissionId}/manual-verify`)
        .then(() => {
          dispatch('read')
          return Promise.resolve()
        })
        .catch(error => {
          return Promise.reject(error)
        })
    },

    /**
     * Get the verification image for a submission
     * @param {Object} commit - The commit function
     * @param {string} submissionId - The ID of the submission
     * @returns {Promise<Blob>} The verification image
     */
    async getVerificationImage({ commit }, imageId) {
        try {
          return await axios.admin.get(`/web3/submissions/image-verification/${imageId}`, {
            responseType: 'blob'
          })
        } catch (err) {
          console.error(err)
        }
    },

    /**
     * Change the status of a submission
     * @param {Object} commit - The commit function
     * @param {Object} payload - The payload containing the ID, status, and reason
     * @returns {Promise<Object>} The response from the API
     */
    async changeStatus({ dispatch }, payload) {
      try {
        await MessageBox.confirm(
          'Do you really want to change the status of this submission?',
          'Change Status', {
              confirmButtonText: 'Yes', cancelButtonText: 'No', type: 'warning'
          }
        )
        await axios.admin.post(`/web3/submissions/image-verification/status/${payload.id}`, {
          status: payload.status,
          reason: payload.reason
        })
        dispatch('read')
        
      } catch (err) {
        console.error(err)
      }
    }
  },

  getters: {
    getSubmissions(state) {
      return state.submissions
    }
  }
}
